import { render, staticRenderFns } from "./UserStyles.vue?vue&type=template&id=40da0500&scoped=true&"
import script from "./UserStyles.vue?vue&type=script&lang=js&"
export * from "./UserStyles.vue?vue&type=script&lang=js&"
import style0 from "./UserStyles.vue?vue&type=style&index=0&id=40da0500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da0500",
  null
  
)

export default component.exports